import { useIsTreatmentVariantByUser } from "../../utils";

export const useAllowChoseBuiltInProfile = () => {
  const EXPERIMENT_KEY =
    "qfd-1033-allow-certain-users-to-chose-hp-built-in-profiles";
  const { isTreatment } = useIsTreatmentVariantByUser(EXPERIMENT_KEY);
  return isTreatment;
};
